const sampleResult = [
  {
    category: "VS",
    total: 16,
    completed: 0,
    percentage: 18.75,
  },
  {
    category: "MD",
    total: 1,
    completed: 0,
    percentage: 0,
  },
  {
    category: "DU",
    total: 3,
    completed: 0,
    percentage: 0,
  },
  {
    category: "DT",
    total: 1,
    completed: 0,
    percentage: 0,
  },
  {
    category: "DM",
    total: 3,
    completed: 0,
    percentage: 0,
  },
]
export { sampleResult }
